import React, { useEffect, useState } from 'react';
import { FieldArray, Form, Formik } from 'formik';
import FormikFieldWrapper from '../general/formikFieldWrapper/formikFieldWrapper';
// @ts-ignore
import { Button, Loader } from 'arag-ui-lib';
import styles from './claimCommunicatorForm.module.scss';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import codes from '../../utils/constants/codes';
import {
    Content,
    ErrorInsideForms,
    Filters,
    GroupButtons,
} from '../../hosc/filters/filters';

import ClaimCommunicatorFilesArray from './ClaimCommunicatorFilesArray';
import useStateIfMounted from '../../hooks/useStateIfMounted';
import { AbortController } from '@azure/abort-controller';
import { useTranslation } from 'react-i18next';

type Props = {
    postCommunicatorMessageLoading: boolean;
    handleMessageSubmit: (values: any) => any;
    claimApplication: any;
};

const ClaimCommunicatorForm = (props: Props) => {
    const {
        postCommunicatorMessageLoading,
        handleMessageSubmit,
        claimApplication,
    } = props;
    const [isUploadingFile, setUploadingfile] = useState(null);
    const [progress, setProgress] = useStateIfMounted<
        Array<{ id: string; progress: number }> | any[]
    >([]);
    const { t } = useTranslation();
    return (
        <div className={'row'}>
            <div className={'form-horizontal'}>
                <Formik
                    initialValues={{
                        files: [
                            {
                                file: null,
                                id: null,
                            },
                        ],
                        content: '',
                    }}
                    onSubmit={handleMessageSubmit}
                    validate={GENERAL_FUNCTIONS.validateCommunicatorComments}
                    validateOnChange={false}
                    validateOnBlur={false}
                >
                    {({ values, setFieldValue, errors }: any) => {
                        return (
                            <div>
                                <Form
                                    className="form-horizontal"
                                    autoComplete="off"
                                    autoCorrect="off"
                                    spellCheck="true"
                                >
                                    <Filters>
                                        <Content>
                                            <div
                                                className={styles['container']}
                                                id="container"
                                            >
                                                <FormikFieldWrapper
                                                    infoText={t(
                                                        'receiveResponseFiveDays',
                                                    )}
                                                    labelSize={'col-sm-3'}
                                                    inputSize={'col-sm-7'}
                                                    label={t('message')}
                                                    variant={'textarea'}
                                                    inputProps={{
                                                        name: 'content',
                                                    }}
                                                />
                                            </div>
                                            <FieldArray
                                                name="files"
                                                render={arrayHelpers => (
                                                    <div>
                                                        {values['files'] &&
                                                        values['files'].length >
                                                            0
                                                            ? values[
                                                                  'files'
                                                              ].map(
                                                                  (
                                                                      file: any,
                                                                      index: number,
                                                                  ) => {
                                                                      return (
                                                                          <ClaimCommunicatorFilesArray
                                                                              key={
                                                                                  file?.id ??
                                                                                  index
                                                                              }
                                                                              index={
                                                                                  index
                                                                              }
                                                                              file={
                                                                                  file
                                                                              }
                                                                              arrayHelpers={
                                                                                  arrayHelpers
                                                                              }
                                                                              error={
                                                                                  errors
                                                                              }
                                                                              setFieldValue={
                                                                                  setFieldValue
                                                                              }
                                                                              files={
                                                                                  values[
                                                                                      'files'
                                                                                  ]
                                                                              }
                                                                              setUploadingfile={
                                                                                  setUploadingfile
                                                                              }
                                                                              isUploadingFile={
                                                                                  isUploadingFile
                                                                              }
                                                                              postCommunicatorMessageLoading={
                                                                                  postCommunicatorMessageLoading
                                                                              }
                                                                              claimApplication={
                                                                                  claimApplication
                                                                              }
                                                                              progress={
                                                                                  progress
                                                                              }
                                                                              setProgress={
                                                                                  setProgress
                                                                              }
                                                                          />
                                                                      );
                                                                  },
                                                              )
                                                            : null}
                                                    </div>
                                                )}
                                            />
                                            {errors && errors.generals && (
                                                <ErrorInsideForms>
                                                    <small className="text-danger">
                                                        {errors.generals}
                                                    </small>
                                                </ErrorInsideForms>
                                            )}
                                        </Content>
                                        <GroupButtons
                                            main={
                                                <Button
                                                    variant="primary"
                                                    label={t('submit')}
                                                    arrowDirection="right"
                                                    disabled={
                                                        isUploadingFile !==
                                                            null ||
                                                        progress?.find(
                                                            i => i.progress,
                                                        )?.progress <
                                                            codes.progressEnd
                                                    }
                                                    type={'submit'}
                                                />
                                            }
                                            rest={
                                                postCommunicatorMessageLoading && (
                                                    <Loader
                                                        variant="inline"
                                                        label={t('submitting')}
                                                    />
                                                )
                                            }
                                        />
                                    </Filters>
                                </Form>
                            </div>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

export default ClaimCommunicatorForm;
